// extracted by mini-css-extract-plugin
export default {"middle":"middle__tzc8d"};